import styled from 'styled-components'

import { FlexAlignCenter, Title } from '../CommonStyleComponents'

export const Container = styled.div<{
  isMobile?: boolean
  isConversationsEnabled?: boolean
}>`
  max-width: ${(props) => (props.isMobile ? '100%' : '360px')};

  .detail-sent {
    color: #fa4f38;
    margin: 10px 0;
    text-align: center;
    display: block;
    ${(props) =>
      props.isMobile &&
      `
    margin-top: -30px;
    `}
  }
`

export const TitleWrap = styled(FlexAlignCenter)`
  justify-content: space-between;

  ${Title} {
    margin-left: 10px;
  }
  svg {
    width: 38px;
    height: auto;
    margin-right: 10px;
  }
`
